import React, { Component } from "react";
import { getContentWrapperClass } from "./../../utils/header/";

class AccessDenied extends Component {
  render() {
    const heading = this.props.heading;
    const text = this.props.text;
    return (
      <div className={getContentWrapperClass(this.props)}>
        <div className="voucherHistorySection">
          <div className="row mt-3">
            <div className="col-md-12 mt-5"></div>
            <div className="col-md-12 mt-5">
              <div className="headingSection mt-5 text-center">
                <img
                  width="40px"
                  height="40px"
                  src="/admin/img/icons/Denied.svg"
                />
                <h1 className="text-center">
                  {heading ? heading : "Access Denied!"}
                </h1>
                <p style={{ fontSize: "16px", fontWeight: "500" }}>
                  {text
                    ? text
                    : "Oops! Looks like you don't have the permission to access this page."}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AccessDenied;
